// Third party libraries
import React from 'react';
import { connect } from 'react-redux';
import { Header, Segment } from 'semantic-ui-react';
import Moment from 'moment';

// Components
import GeneralOfferForm from './forms/generalOffer'

// Locales
import I18n from '../../../../../i18n';

const defaultOffer = {
  _id: '',
  discount: 0,
  type: 'monthly',
  expirationDate: Moment().format()
}

class ProPlansOffers extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedOffer: defaultOffer
    }
  }

  componentDidMount() {

    this.onGetOfferType('monthly');
     
  }

  onGetOfferType(value) {

    const { plan } = this.props;

    const offer = plan.generalOffers.find(offer => offer.type === value);

    if(offer) {
      
      this.setState({
        selectedOffer: offer
      });

    } else {

      defaultOffer.type = value;

      this.setState({
        selectedOffer: defaultOffer
      });

    }

  }
    
  render() {

    const { plan } = this.props;

    return (
      <div className='pro-plans-offers'>
        <Header as='h3'>{ I18n.t('plans.offers') }</Header>
        <Segment id="generalDiscount">
            <Header as='h4'>{ I18n.t('plans.generalOffers') }</Header>
            <GeneralOfferForm 
              initialValues={{
                discount: this.state.selectedOffer?.discount || 0,
                type: this.state.selectedOffer?.type || 'monthly',
                expirationDate: this.state.selectedOffer?.expirationDate,
                stripeCouponId: this.state.selectedOffer?.stripeCouponId || ''
              }}
              offerId={ this.state.selectedOffer._id}
              plan={ plan }
              onChange={(values)=> this.onGetOfferType(values.type)}
              {...this.props}
            />
        </Segment>
      </div>
    )
  }

}

export default connect(null, {})(ProPlansOffers)